import { mapGetters, mapState } from 'vuex';

import formatterMixin from './formatterMixin';

const userActivitiesMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      loading: state => state.userActivities.loading,
      uaMembers: state => state.userActivities.uaMembers,
      uaTableOptions: state => state.userActivities.uaTableOptions,
      uaTableSearch: state => state.userActivities.uaTableSearch,
      uaSelectedCustomer: state => state.userActivities.uaSelectedCustomer,
      processing: state => state.userActivities.processing,
      selectedDate: state => state.userActivities.selectedDate,
      selectedEventCode: state => state.userActivities.selectedEventCode,
      userActivityTableSearch: state => state.userActivities.userActivityTableSearch,
      typeOptions: state => state.userActivities.typeOptions,
      sortedCorporation: state => state.userActivities.sortedCorporation,
      selectedPartner: state => state.userActivities.selectedPartner,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'userActivityTableRecordCount',
      'userActivityTableData',
      'allBranches',
    ]),
  },
  methods: {
    changeRowCount(rowCount) {
      this.$store.dispatch('uaChangeTableOption', {
        field: 'itemsPerPage',
        value: rowCount,
      });
    },
    changePage(page) {
      this.$store.dispatch('uaChangeTableOption', {
        field: 'page',
        value: page,
      });
    },
    changeUserActivityValues(changes) {
      this.$store.dispatch('changeUserActivitiesValues', changes);
    },
    changePartner(corpId) {
      this.$store.dispatch('changeUserActivitiesValues', [{
        field: 'selectedPartner',
        value: corpId,
      }]);
      this.$store.dispatch('getUserActivities');
    },
  },
};
export default userActivitiesMixin;
